import {
  SettingItemActionType,
  ActionProps,
  useSettingItemAction
} from "@/pages/settings/components/settingsItems/hooks/useSettingItemAction";
import Text, { TextVariant } from "@/components/ui/text";
import { cn } from "@/utils/utils";
import React, { ReactNode } from "react";

export interface SettingItemLayoutProps {
  title?: string;
  subTitle?: string;
  subTitleBreakAfterSentence?: boolean;
  icon?: JSX.Element;
  actionType?: SettingItemActionType;
  actionProps?: ActionProps;
  customAction?: ReactNode;
  textValue?: string | JSX.Element;
  className?: string;
  titleClassName?: string;
  isLastItem?: boolean;
  titleVariant?: TextVariant;
}

const SettingItemLayout: React.FC<SettingItemLayoutProps> = ({
  title,
  subTitle,
  subTitleBreakAfterSentence = false,
  icon,
  actionType,
  actionProps,
  customAction,
  textValue,
  className = "",
  titleClassName = "",
  isLastItem = false,
  titleVariant = "body"
}) => {
  const { renderAction } = useSettingItemAction();

  const isTextareaAction =
    actionType === "textarea" || actionType === "textEditor";

  return (
    <div
      className={cn(
        "w-full flex flex-col p-4 items-start justify-center",
        !isLastItem ? "border-b border-border-border1" : "",
        className
      )}
    >
      <div
        className={cn(
          "w-full",
          isTextareaAction
            ? "flex flex-col gap-3"
            : "flex flex-row justify-between items-center gap-4"
        )}
      >
        <div className={cn((textValue || icon) && "flex", icon && "gap-4")}>
          {icon && icon}
          <div
            className={cn(
              "flex flex-col justify-start",
              textValue && "min-w-[10rem] max-w-[10rem]"
            )}
          >
            <Text variant={titleVariant} className={titleClassName}>
              {title}
            </Text>
            {subTitle && (
              <Text
                variant="bodySecondary"
                className={
                  subTitleBreakAfterSentence ? "whitespace-pre-line" : undefined
                }
              >
                {subTitle}
              </Text>
            )}
          </div>
          {textValue && typeof textValue === "string" ? (
            <Text>{textValue}</Text>
          ) : (
            textValue
          )}
        </div>
        {customAction
          ? customAction
          : actionType && actionProps
            ? renderAction(actionType, actionProps)
            : null}
      </div>
    </div>
  );
};

export default SettingItemLayout;
